















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrderHistoryData } from '@/api/types'
import { sortByDate, sortByString } from '@/utils/sort'

@Component({
  name: 'OrderHistoryTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IOrderHistoryData>;

  @Prop({ type: Boolean })
  listLoading = true;

  sortHistoryType(a: IOrderHistoryData, b: IOrderHistoryData): number {
    return sortByString(a.historyType, b.historyType)
  }

  sortHistoryStatus(a: IOrderHistoryData, b: IOrderHistoryData): number {
    return sortByString(a.historyStatus, b.historyStatus)
  }

  sortStatusDate(a: IOrderHistoryData, b: IOrderHistoryData): number {
    return sortByDate(a.statusChangeDate, b.statusChangeDate)
  }
}
